import React from "react";
import { createRoot } from "react-dom/client";
// Library and shared CSS, in the order it had before routes were lazy-loaded.
// Importing it here keeps all CSS in bundle.css in that order; components
// still import what they use.
import "react-toastify/dist/ReactToastify.css";
import "cropperjs/dist/cropper.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "tippy.js/dist/tippy.css";
import "react-show-more-text/lib/ShowMoreText.css";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import "react-data-table-component/css";
import "react-perfect-scrollbar-z/build/styles.css";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "katex/dist/katex.min.css";
import "highlight.js/styles/github-dark.css";
import "./app/shared/components/richcontent/RichContent.scss";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import './index.scss';
import { Provider } from 'react-redux';
import { store, persistor } from './app/redux/store';
import { PersistGate } from "redux-persist/integration/react";

const root = createRoot(document.getElementById("root"));
root.render( 
<Provider store={store}>
<PersistGate loading={null} persistor={persistor}>
<App />
</PersistGate>
</Provider>    

);
  